import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

import {RootState} from 'app/store';
import {IChannel} from 'models/channels';

interface IChannelQuery {
  limit?: number;
  kidsMode?: boolean;
  activeRegion?: string;
  offset?: number;
  sort?: string;
}

export const channelsApi = createApi({
  reducerPath: 'channelsApi',
  tagTypes: ['Channels'],
  baseQuery: fetchBaseQuery({
    baseUrl: '/v1/',
    prepareHeaders(headers, {getState}) {
      const token = (getState() as RootState).user.jwt;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: builder => ({
    find: builder.query<IChannel[], IChannelQuery>({
      query: ({limit = 2000, kidsMode, activeRegion, offset = 0, sort}) => {
        let url = `channels?limit=${limit}`;

        if (offset) {
          url = `${url}&offset=${offset}`;
        }

        if (sort) {
          url = `${url}&sort=${sort}`;
        }

        if (kidsMode) {
          url = `${url}&kidsMode=true`;
        }

        if (activeRegion) {
          url = `${url}&activeRegion=${activeRegion.toUpperCase()}`;
        }

        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['Channels'],
    }),
  }),
});

export const {useFindQuery} = channelsApi;
